import { Swiper } from 'swiper';
import { elementExists } from '../../core/utils';
const HeroCarousel = () => {
  const carousels = document.querySelectorAll('.hero-carousel.has-slides');
  if (!elementExists(carousels, true)) return;
  carousels.forEach(function (carousel) {
    if (carousel.classList.contains('slider_started')) {
      return;
    }
    const id = carousel.getAttribute('id');
    const dataset = carousel.dataset;
    const autoplay = dataset.autoplay;
    const stopAutoplay = dataset.stopAutoplay;
    const delay = dataset.delay * 1000;
    const speed = dataset.speed * 1000;
    const showBullets = dataset.showBullets;
    const showNavigation = dataset.showNavigation;

    let swiperParms = {
      effect: dataset.effect,
      speed: speed,
      loop: true,
      centeredSlides: false,
      autoHeight: false,
      calculateHeight: false,
      keyboard: true,
      autoplay: false,
    };
    if (showNavigation) {
      const nextEl = carousel.querySelector('.swiper-button-next');
      const prevEl = carousel.querySelector('.swiper-button-prev');
      swiperParms.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };
    }
    if (showBullets) {
      const paginationEl = carousel.querySelector('.swiper-pagination');
      swiperParms.pagination = {
        el: paginationEl,
        clickable: true,
        type: 'bullets',
        renderBullet: function (index, className) {
          return `<span class="${className}"><em>
							${index + 1}
							</em><i></i><b></b></span>`;
        },
      };
    }
    if (autoplay) {
      swiperParms.autoplay = {
        delay: delay,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
        waitForTransition: true,
      };
    }
    const swiper = new Swiper(`#${id} .swiper`, swiperParms);

    swiper.on('slideChange', function () {
      carousel.style.setProperty('--bullet-duration', `${delay + speed}ms`);
    });

    swiper.on('beforeTransitionStart', function () {
      // colorScheme(this);
    });

    swiper.on('slideChange', function () {
      // colorScheme(this);
    });

    // function colorScheme(context) {
    // 	//const parent = context.el.parentcarousel;
    // 	const parent = carousel.querySelector(".slideshow-bottom");
    // 	const activeIndex = context.activeIndex;
    // 	const activeSlide = context.slides[activeIndex];
    // 	const changeItems = [parent];
    // 	const colorScheme = activeSlide.querySelector(".slideshow-slide").dataset.colorScheme;

    // 	changeItems.forEach(function (item) {
    // 		item.classList.forEach(function (className) {
    // 			if (/color-background-\d+$/.test(className)) {
    // 				item.classList.remove(className);
    // 			}
    // 		});
    // 		item.classList.add(colorScheme);
    // 	});
    // }
  });
};

export default HeroCarousel;
